<script lang="ts">
    import { fly } from "svelte/transition";
    import LL from "../../../../i18n/i18n-svelte";
    import { isMobileOnboarding } from "../../../Stores/OnboardingStore";

    interface Props {
        onnext?: () => void;
    }

    const { onnext }: Props = $props();

    function handleNext() {
        onnext?.();
    }
</script>

<!-- Mobile onboarding: panel at bottom so user sees the bubble video above. Desktop: panel on the right. -->
<div
    class="z-3001 pointer-events-auto {$isMobileOnboarding
        ? 'fixed left-4 right-8 bottom-[4.5rem]'
        : 'fixed bottom-20 -right-10 transform -translate-x-14'}"
>
    <div
        data-testid="onboarding-card"
        class="bg-mlight/80 shadow-light rounded-md2 backdrop-blur-lg p-4 sm:p-6 w-full max-w-[550px] border border-white/20 {$isMobileOnboarding
            ? 'mx-auto max-h-[40vh] overflow-y-auto'
            : ''}"
        in:fly={{ y: $isMobileOnboarding ? 10 : 10, duration: 400 }}
    >
        <div class="text-center">
            <h3 class="text-lg sm:text-[32px] sm:leading-7 font-bold text-mdark mb-3">
                {$LL.onboarding.communication.title()}
            </h3>
            <p class="text-base text-mdark/90 m-0">
                {$LL.onboarding.communication.description()}
            </p>
            {#if $LL.onboarding.communication.video() && !$isMobileOnboarding}
                <!-- <video autoplay muted loop playsinline class="w-full rounded-lg my-5">
                    <source src={$LL.onboarding.communication.video()} type="video/mp4" />
                </video> -->
                <img
                    class="w-full rounded-lg my-5 h-[280px]"
                    src="./static/images/Onboarding_Communication.png"
                    alt="Onboarding_Communication"
                />
            {/if}
            <button
                class="mt-5 px-5 py-3 bg-mblue hover:bg-mblue-darker text-white rounded-lg font-medium transition-all text-[13px]"
                onclick={handleNext}
            >
                {$LL.onboarding.communication.next()}
            </button>
        </div>
    </div>
</div>
